import { SelectTools, SolSelectValue, SolText } from '@sol/components';
import { Scope, Partner, Subscope } from '../services/session.service';
import { ScopeTools } from './scope-tools';

export class AsmNavbarTools {
  public static toPartnerSelectValues(partners: Partner[], includeAll: boolean = false): SolSelectValue[] {
    const partnerValues: SolSelectValue[] = partners
      .map(s => ({
        id: s.id,
        name: SolText.ofRaw(s.name),
      }))
      .sort(SelectTools.sort);

    if (includeAll) {
      partnerValues.unshift({
        id: undefined,
        name: SolText.of('asm-components.navbar.all-partners'),
      });
    }

    return partnerValues;
  }

  public static toScopeSelectValues(scopes: Scope[], includeAll: boolean = false): SolSelectValue[] {
    const scopeValues: SolSelectValue[] = scopes
      .map(s => ({
        id: s.name,
        name: SolText.ofRaw(ScopeTools.scopeToName(s)),
      }))
      .sort(SelectTools.sort);

    if (includeAll) {
      scopeValues.unshift({
        id: undefined,
        name: SolText.of('asm-components.navbar.all-scopes'),
      });
    }
    return scopeValues;
  }

  public static toSubscopeSelectValues(subscopes: Subscope[]): SolSelectValue[] {
    const globalScopeValues: SolSelectValue[] = subscopes.find(s => s.id === undefined)
      ? []
      : [
          {
            id: undefined,
            name: SolText.of('asm-components.scope.global'),
          },
        ];
    const subscopeValues = subscopes.map(s => ({
      id: s.id || undefined,
      name: SolText.ofRaw(s.displayName),
    }));
    return [...globalScopeValues, ...subscopeValues].sort(SelectTools.sort);
  }
}
